import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Routes from '../src/routes';
import Store from './store';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
// import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <Routes />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
